import Vue from "vue";
import VueRouter from "vue-router";

// import Home from "./views/Home.vue";
import AnimeDetail from "@/views/AnimeDetail";
import NotFound from "@/views/NotFound";
import CommunityMin from "@/views/CommunityMin";
import EpisodeView from "@/views/EpisodeView";
import LandingPageAnime from "@/views/LandingPageAnime";
import ReaderView from "@/views/ReaderView";
import BookDetail from "@/views/BookDetail";
import Search from "@/views/Search";
import LandingPageBooks from "@/views/LandingPageBooks";
import MyAccount from "@/views/MyAccount";
import MyLiked from "./views/MyLiked.vue";
import PageView from "@/views/PageView";
import ErrorView from "@/views/ErrorView";
import MyWatchlist from "./views/MyWatchlist";
import ShowDetailNew from "./views/ShowDetail.vue";

Vue.use(VueRouter);

const routes = [
    {
        path: "/home",
        redirect: { name: "landingAnime" },
        name: "inicio",
        // component: Home
    },
    {
        path: "/search",
        name: "buscar",
        component: Search
    },
    {
        path: "/watch",
        name: "landingAnime",
        component: LandingPageAnime
    },
    {
        path: "/watch/:name",
        name: "animedetail",
        component: AnimeDetail
    },
    {
        path: "/watch_beta/:name",
        name: "show_detail",
        component: ShowDetailNew
    },
    {
        path: "/watch/:serie/:temporada/:episodio",
        name: "episodeview",
        component: EpisodeView
    },
    {
        path: "/lectorem",
        name: "landingBook",
        component: LandingPageBooks
    },
    {
        path: "/lectorem/reader/:uuid",
        name: "reader",
        component: ReaderView
    },
    {
        path: "/lectorem/:titulo",
        name: "lectoremdetail",
        component: BookDetail
    },
    {
        path: "/pages/:page",
        name: "PageView",
        component: PageView
    },
    {
        path: "/community",
        name: "comunidad",
        component: CommunityMin
    },
    {
        path: "/my/account",
        name: "myaccount",
        component: MyAccount
    },
    {
        path: "/my/favorites",
        name: "liked",
        component: MyLiked
    },
    {
        path: "/my/watchlist",
        name: "mywatchlist",
        component: MyWatchlist
    },
    {
        path: "/error",
        name: "error",
        component: ErrorView
    },
    {
        path: "/",
        redirect: { name: "landingAnime" }
    },
    {
        path: "*",
        name: "notfound",
        component: NotFound
    }
];

const router = new VueRouter({
    mode: "history",
    routes,
    scrollBehavior (to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return { x: 0, y: 0 }
        }
    }
});

export default router;
